import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconPaymentError.tsx
const IconPaymentError = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M17.435 16.216a1.57 1.57 0 0 1 1.574-1.564H30.2l-.01-8.435c0-.869-.7-1.574-1.564-1.574l-25.25.01c-.868 0-1.573.7-1.573 1.564l.01 15.519c0 .868.7 1.573 1.563 1.573h14.06zM6.258 13.67V7.976h4.525q1.395 0 2.36.504.967.498 1.465 1.354.505.849.505 1.91 0 1.1-.51 1.939-.51.831-1.477 1.307-.967.468-2.343.468H8.427v.891h2.63v1.787h-2.63v1.84H6.258v-1.84H4.495v-1.787h1.763v-.89H4.495V13.67z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ jsx("path", { d: "M10.783 9.78q.732 0 1.206.264.48.258.714.71.241.445.235 1.008.006.573-.235 1a1.6 1.6 0 0 1-.726.668q-.486.24-1.242.241H8.427v-3.89zM20.62 19.815l1.886-1.886 7.543 7.543-1.886 1.885z" }),
			/* @__PURE__ */ jsx("path", { d: "m20.62 25.472 7.543-7.543 1.886 1.886-7.543 7.542z" })
		]
	})]
});
var IconPaymentError_default = forwardRef(IconPaymentError);
//#endregion
export { IconPaymentError_default as default };
